/**
 * Copyright © 2025 Delicious AI, LLC
 *
 * @author Bryan Sheranian <bryan.sheranian@deliciousai.com>
 */

import { gql } from '@apollo/client'

import { PRODUCT_FRAGMENT } from '../fragments/ProductFragment'

export const GET_PRODUCTS = gql`
  query GetProducts(
    $filters: ProductFilter
    $pagination: OffsetLimitPaginationFilter
  ) {
    products(filters: $filters, pagination: $pagination) {
      totalCount
      results {
        ...Product
      }
    }
  }
  ${PRODUCT_FRAGMENT}
`
